import React from 'react'
import { Link } from 'react-router-dom'

import { KTIcon } from '../../../../../_metronic/helpers'
import { SmartTooltip } from '../../../../../components/SmartTooltip/SmartTooltip'
import styles from './DisputeBadge.module.css'

interface Props {
  /** Токен тикета — для deep-link в журнал, сразу отфильтрованный по этому тикету. */
  ticketToken: string
  /**
   * Делать бейдж ссылкой в журнал. Только для тех, у кого есть доступ к журналу (admin/manager):
   * иначе клик вёл бы на страницу, закрытую ролью (CPAYMENT-1615). Без ссылки — просто бейдж с
   * той же подсказкой.
   */
  linkable?: boolean
}

/**
 * Сигнал «по тикету идёт спор, тикет заморожен» (CPAYMENT-1615).
 *
 * Строка в очереди подсвечена — оператор пропускает её при беглом просмотре; подсказка объясняет,
 * что заблокировано. Для ролей с доступом к журналу бейдж ещё и ссылка (новая вкладка).
 *
 * Правило SmartTooltip: дочерний элемент должен класть переданные props на реальный DOM-узел —
 * и `Link`, и `<span>` разворачивают их на свой корневой элемент, поэтому подсказка работает.
 */
export const DisputeBadge: React.FC<Props> = ({ ticketToken, linkable = false }) => {
  const tooltip = (
    <div>
      <div className='fw-bold mb-1'>По тикету открыт диспут</div>
      <div>
        Чек нельзя подтвердить или отклонить, сумму нельзя изменить. Тикет закроется, когда
        администратор или менеджер примет решение по спору.
      </div>
      {linkable && (
        <div className='mt-2 opacity-75'>Клик — журнал диспутов по этому тикету в новой вкладке.</div>
      )}
    </div>
  )

  const badgeClass = `badge badge-light-warning d-inline-flex align-items-center gap-1`

  return (
    <SmartTooltip content={tooltip}>
      {linkable ? (
        <Link
          to={`/matching/disputes?paymentTicketToken=${ticketToken}`}
          target='_blank'
          rel='noopener noreferrer'
          className={`${badgeClass} ${styles.disputeLink}`}
          aria-label='Открыть журнал диспутов по этому тикету в новой вкладке'
        >
          <KTIcon iconName='shield-cross' className='fs-7' />
          Диспут
          <KTIcon iconName='exit-right-corner' className={`fs-8 ${styles.externalIcon}`} />
        </Link>
      ) : (
        <span className={badgeClass} style={{ cursor: 'default' }}>
          <KTIcon iconName='shield-cross' className='fs-7' />
          Диспут
        </span>
      )}
    </SmartTooltip>
  )
}

export default DisputeBadge
